import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Tab from '@ts-core/components/Tab';
import Tabs from '@ts-core/components/Tabs';

const useStyles = makeStyles(() => ({
  tabs: {
    minWidth: 96,
  },
}));

const SubjectPageHeader = (props) => {
  const classes = useStyles();
  const { title, tabs, activeTab, onGoToTab } = props;

  const handleChangeTab = useCallback(
    (event, newValue) => {
      onGoToTab(newValue);
    },
    [onGoToTab]
  );

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Box>
        <Typography variant="h6">{title}</Typography>
      </Box>
      <Box>
        {activeTab && (
          <Tabs
            value={activeTab?.slug}
            onChange={handleChangeTab}
            className={classes.tabs}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.slug}
                icon={tab.icon}
                value={tab.slug}
                label={tab.label}
              />
            ))}
          </Tabs>
        )}
      </Box>
    </Box>
  );
};

SubjectPageHeader.propTypes = {
  title: PropTypes.string,
  tabs: PropTypes.array,
  activeTab: PropTypes.object,
  onGoToTab: PropTypes.func,
};

SubjectPageHeader.defaultProps = {
  title: '',
  tabs: [],
  activeTab: undefined,
  onGoToTab() {},
};

export default SubjectPageHeader;
